import { styled } from 'styled-components';
import { colorToStr, HSLToRGB, RGBToHSL, strToColor } from 'Common/util/Color';

export enum ButtonTheme {
  blue = 'BLUE',
  green = 'GREEN',
  red = 'RED',
  secondary = 'SECONDARY'
}

interface ButtonThemeValues {
  background: string;
  hoverBackground: string;
  boxShadowColor: string;
}

const ButtonThemes: { [key in ButtonTheme]: ButtonThemeValues} = {
  [ButtonTheme.blue]: {
    background: '#008AFF',
    hoverBackground: '#0070D6',
    boxShadowColor: 'rgba(0, 138, 255, 0.25)'
  },
  [ButtonTheme.green]: {
    background: '#2ab15d',
    hoverBackground: '#158739',
    boxShadowColor: 'rgba(31,136,72,0.25)'
  },
  [ButtonTheme.red]: {
    background: '#b12a2a',
    hoverBackground: '#871515',
    boxShadowColor: 'rgba(136,31,31,0.25)'
  },
  [ButtonTheme.secondary]: {
    background: '#6B7085',
    hoverBackground: '#525669',
    boxShadowColor: 'rgba(107, 112, 133, 0.25)'
  }
}

export const Button = styled.button<{ $theme?: ButtonTheme }>`
  padding: 10px 22px;
  background: ${({ $theme = ButtonTheme.blue }) => ButtonThemes[$theme].background};
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.2px;
  cursor: pointer;
  transition: all 0.15s ease;
  white-space: nowrap;

  &:hover {
    background: ${({ $theme = ButtonTheme.blue }) => ButtonThemes[$theme].hoverBackground};
    box-shadow: 0 4px 12px -2px ${({ $theme = ButtonTheme.blue }) => ButtonThemes[$theme].boxShadowColor};
  }

  &:active {
    transform: translateY(1px);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px ${({ $theme = ButtonTheme.blue }) => ButtonThemes[$theme].boxShadowColor};
  }

  &:disabled {
    background: ${({ $theme = ButtonTheme.blue }) => {
      const rgb = strToColor(ButtonThemes[$theme].background);
      if (rgb === null) {
        return '#666';
      }
      const hsl = RGBToHSL(rgb);
      return colorToStr(
        HSLToRGB(
          [hsl[0], hsl[1] * .2, hsl[2]]
        )
      )
    }};
    cursor: not-allowed;
  }
`;
